/**
 * Checks for empty rich-text html strings
 */
export const isEmptyHtml = (html: string): boolean => {
  if (!html) {
    return true
  }
  const regex = /(<([^>]+)>)/g
  const isEmpty = !html.replace(regex, '').trim().length

  return isEmpty
}
